export default __webpack_public_path__ + "static/award-logo-2-e3eb49c1cc256f63d94d79611e0956ee.svg";